import { Grid } from '@mui/material';
import { RouterManager } from './router/RouterManager';
import { Toaster } from 'sonner';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './redux/store';

import { setAuth, clearAuth } from './services/auth.service';
import { authUser } from './store/userInfoSlice';

function App() {

   const dispatch = useDispatch<AppDispatch>();
   const { authenticated } = useSelector((state: RootState) => state.userInfo);

   useEffect(() => {
     async function checkAuth() {
       const token = localStorage.getItem('token');
       if (token) {
         await setAuth(token);
       } else {
         if (authenticated) {
           dispatch(authUser(false));
         }
         await clearAuth();
       }
     }
     checkAuth();
   }, [authenticated, dispatch]);

   return (
      <Grid 
         container 
         sx={{ 
           display: "flex", 
           justifyContent: "center",
           width: "100%",
           minHeight: "100vh"
         }}
      >
         <Toaster richColors position="bottom-right" />
         <RouterManager />
      </Grid>
   );
}

export default App;
